(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompListAccService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 185,
                    parameters: parms || {}
                });
            },
            getStatus: function (parms) {
                return $ihttp.post({
                    method: 211,
                    parameters: parms || {}
                });
            },
            listLastPicked: function (parms) {
                return $ihttp.post({
                    method: 232,
                    parameters: parms || {}
                });
            },
            listAccumulatedComponents: function (parms) {
                return $ihttp.post({
                    method: 184,
                    parameters: parms || {}
                });
            },
            abortFinishing: function (edit) {
                return $ihttp.post({
                    method: 212,
                    parameters: edit
                });
            },
            updateQuantityToPick: function (edit) {
                return $ihttp.post({
                    method: 186,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
